/**
 * SHA-256 of a string, as lowercase hex.
 *
 * Used to detect that two deterministic simulations drifted apart. A digest
 * never authorises a reward: the server computes rewards from its own state
 * and would reach the same numbers if the client sent no digest at all.
 *
 * Web Crypto and `TextEncoder` are declared narrowly rather than pulled in
 * through `lib.dom` or `@types/node`: this package must keep compiling with
 * `types: []`, and both globals exist in every runtime the project targets -
 * browsers, Cloudflare Workers and Node 18+.
 */
declare const crypto: {
  readonly subtle: {
    digest(algorithm: string, data: ArrayBufferView | ArrayBuffer): Promise<ArrayBuffer>;
  };
};
declare const TextEncoder: {
  new (): { encode(input: string): Uint8Array };
};

export async function sha256Hex(text: string): Promise<string> {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
